(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rimboccare-installments"] && !Shopify.designMode) return;
  try {
    (function () {
    var selector = '[data-rimboccare-installments]';

    function parseMoney(text) {
      var match = String(text || '').match(/-?\d[\d.,]*/);
      var value = match ? match[0] : '';
      var normalized;

      if (!value) return 0;

      if (value.indexOf(',') !== -1 && value.indexOf('.') !== -1) {
        normalized = value.replace(/,/g, '');
      } else if (value.indexOf(',') !== -1) {
        normalized = /,\d{2}$/.test(value)
          ? value.replace(/\./g, '').replace(',', '.')
          : value.replace(/,/g, '');
      } else if (/\.\d{2}$/.test(value)) {
        normalized = value;
      } else {
        normalized = value.replace(/\./g, '');
      }

      return Math.round(Number.parseFloat(normalized) * 100) || 0;
    }

    function formatMoney(cents) {
      return 'S/. ' + (cents / 100).toFixed(2);
    }

    function findPriceNode(root) {
      var container;

      if (root.getAttribute('data-source') === 'product') {
        container = root.closest('[data-product-blocks]') || root.parentElement;
        return container ? container.querySelector('[data-product-price]') : null;
      }

      container = root.closest('form') || root.parentElement;
      return container ? container.querySelector('[data-subtotal]') : null;
    }

    function update(root) {
      var target = findPriceNode(root);
      var initialPrice = Number(root.getAttribute('data-initial-price')) || 0;
      var price = target ? parseMoney(target.textContent) : initialPrice;
      var count = Number(root.getAttribute('data-installment-count')) || 6;
      var minimum = Number(root.getAttribute('data-minimum-price')) || 70000;
      var amount = root.querySelector('[data-installment-amount]');
      var countText = root.querySelector('[data-installment-count-text]');
      var shouldShow = price >= minimum;

      root.hidden = !shouldShow;

      if (countText) countText.textContent = String(count);

      if (amount && shouldShow) {
        amount.textContent = formatMoney(Math.floor(price / count));
      }
    }

    function bind(root) {
      var target;

      if (root.getAttribute('data-installments-ready') === 'true') return;

      root.setAttribute('data-installments-ready', 'true');
      update(root);
      target = findPriceNode(root);

      if (target) {
        new MutationObserver(function () {
          update(root);
        }).observe(target, { childList: true, characterData: true, subtree: true });
      }
    }

    function initialize(scope) {
      var roots = [];

      if (scope && scope.matches && scope.matches(selector)) roots.push(scope);
      if (scope && scope.querySelectorAll) {
        roots = roots.concat(Array.from(scope.querySelectorAll(selector)));
      }

      roots.forEach(bind);
    }

    if (!window.RimboccareInstallments) {
      window.RimboccareInstallments = {
        initialize: initialize,
        update: update
      };

      initialize(document);

      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) initialize(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    } else {
      window.RimboccareInstallments.initialize(document);
    }
  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rimboccare-terms-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.rimboccareTermsConsentReady) return;
    window.rimboccareTermsConsentReady = true;

    const consentSelector = '[data-rimboccare-terms]';
    const checkoutSelector = '.cart__checkout, .additional-checkout-buttons button, .additional-checkout-buttons [role="button"]';

    const setState = (consent, showError) => {
      const checkbox = consent.querySelector('.rimboccare-terms__checkbox');
      const error = consent.querySelector('[data-rimboccare-terms-error]');
      if (!checkbox || !error) return true;
      const accepted = checkbox.checked;
      error.hidden = accepted || !showError;
      checkbox.setAttribute('aria-invalid', accepted || !showError ? 'false' : 'true');
      const form = consent.closest('form');
      form?.querySelectorAll(checkoutSelector).forEach((button) => {
        button.dataset.termsAccepted = accepted ? 'true' : 'false';
      });
      return accepted;
    };

    const rejectIfNeeded = (form, event) => {
      const consent = form?.querySelector(consentSelector);
      if (!consent || setState(consent, true)) return false;
      event.preventDefault();
      event.stopImmediatePropagation();
      consent.querySelector('.rimboccare-terms__checkbox')?.focus();
      return true;
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches('.rimboccare-terms__checkbox')) return;
      const consent = event.target.closest(consentSelector);
      if (consent) setState(consent, false);
    });

    document.addEventListener('submit', (event) => {
      rejectIfNeeded(event.target, event);
    }, true);

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const checkout = event.target.closest(checkoutSelector);
      if (!checkout) return;
      rejectIfNeeded(checkout.closest('form'), event);
    }, true);

    const initialize = () => {
      document.querySelectorAll(consentSelector).forEach((consent) => setState(consent, false));
    };

    document.addEventListener('DOMContentLoaded', initialize);
    document.addEventListener('cart:build', initialize);
    initialize();
  })();
  } catch(e) { console.error(e); }
})();

})();
